import { call, put, takeLatest } from "redux-saga/effects";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import { toChucThiApi } from "../../../api/category/toChucThiApi";
import {
  eToChucThiActionIds,
  IToChucThiActionTypes,
} from "../../action-types/category/IToChucThiActions";
import { IThongTinToChucThiRequest } from "../../../model/request/category/IThongTinToChucThiRequest";

export function* toChucThiSaga(): any {
  yield takeLatest(eToChucThiActionIds.LOAD_START, loadWorker);
  yield takeLatest(eToChucThiActionIds.LOAD_DOT_THI_START, loadDotThiWorker);
}

function* loadWorker(action: IToChucThiActionTypes): any {
  const res: IBaseRespone = yield call(
    toChucThiApi.SelectVm,
    action.payload as IThongTinToChucThiRequest
  );
  if (res.is_success) {
    yield put(rootActions.category.toChucThi.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.toChucThi.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* loadDotThiWorker(action: IToChucThiActionTypes): any {
  const res: IBaseRespone = yield call(
    toChucThiApi.SelectDotThiVm,
    action.payload as any
  );
  if (res.is_success) {
    yield put(rootActions.category.toChucThi.LOAD_DOT_THI_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.toChucThi.LOAD_DOT_THI_ERRR(res.message ?? "Có lỗi")
    );
  }
}
